module.exports = "https://static.wanderu.com/ui-react/_next/static/media/shuttle-grey.8673b80a.svg";